import React from 'react';
import { Mail, MapPin, Phone } from 'lucide-react';
import { useLanguage } from '../../../contexts/useLanguage';

const PHONE_HREF = 'tel:+14508335083';
const EMAIL_HREF = 'mailto:info@pourvoiriepignonrouge.com';

const HomeContactFooter: React.FC = () => {
  const { t } = useLanguage();

  return (
    <section id="contact" className="bg-[#2f241c] pt-20 pb-6 text-white">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6 lg:px-8">
        <h2 className="font-felix-titling mb-3 text-4xl font-bold">
          {t('landing.contact.title')}
        </h2>
        <p className="font-felix-titling mb-10 text-lg text-white/80">{t('landing.contact.subtitle')}</p>

        <div className="space-y-6 text-left text-sm text-white/95 sm:mx-auto sm:max-w-xl">
          <div className="flex gap-3">
            <Mail className="mt-0.5 h-5 w-5 shrink-0 text-white/70" aria-hidden />
            <div>
              <div className="text-xs font-medium uppercase tracking-wide text-white/60">{t('landing.contact.email')}</div>
              <a href={EMAIL_HREF} className="mt-1 block break-all text-base font-medium text-white underline decoration-white/40 underline-offset-4 hover:decoration-white">
                {t('landing.contact.emailValue')}
              </a>
            </div>
          </div>

          <div className="flex gap-3">
            <Phone className="mt-0.5 h-5 w-5 shrink-0 text-white/70" aria-hidden />
            <div>
              <div className="text-xs font-medium uppercase tracking-wide text-white/60">{t('landing.contact.phone')}</div>
              <a href={PHONE_HREF} className="mt-1 block text-base font-medium text-white underline decoration-white/40 underline-offset-4 hover:decoration-white">
                {t('landing.contact.phoneValue')}
              </a>
            </div>
          </div>

          <div className="flex gap-3">
            <MapPin className="mt-0.5 h-5 w-5 shrink-0 text-white/70" aria-hidden />
            <div>
              <div className="text-xs font-medium uppercase tracking-wide text-white/60">{t('landing.contact.address')}</div>
              <address className="mt-1 not-italic text-base leading-relaxed text-white/95">{t('landing.contact.addressValue')}</address>
            </div>
          </div>
        </div>
      </div>

      <footer className="mt-16 border-t border-white/20 py-6 text-center text-sm text-white/70">
        © {new Date().getFullYear()} {t('landing.footer.brandName')}. {t('landing.footer.rights')}
      </footer>
    </section>
  );
};

export default HomeContactFooter;
